import { createFileRoute } from '@tanstack/react-router';

import { ConferenceCreate } from '@/module/Conference/ConferenceCreate';

export const Route = createFileRoute('/_auth/conference/_conference/create')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  return <ConferenceCreate />;
}
